webpackJsonp([32,47],{

/***/ 1259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chat_sideboxChat_vue__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_chat_sideboxChat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_chat_sideboxChat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_info_opportunitiesViewModal_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_info_opportunitiesViewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modal_info_opportunitiesViewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteFooter_vue__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SiteFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SiteFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_KendoTable_vue__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_KendoTable_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_KendoTable_vue__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    OpportunitiesModal: __WEBPACK_IMPORTED_MODULE_3__components_modal_info_opportunitiesViewModal_vue___default.a,
    SideboxChat: __WEBPACK_IMPORTED_MODULE_2__components_chat_sideboxChat_vue___default.a,
    SideViewChat: __WEBPACK_IMPORTED_MODULE_2__components_chat_sideboxChat_vue___default.a,
    SiteFooter: __WEBPACK_IMPORTED_MODULE_4__components_SiteFooter_vue___default.a,
    KendoTable: __WEBPACK_IMPORTED_MODULE_5__components_KendoTable_vue___default.a
  },
  data: function data() {
    return {
      search: '',
      selectedRow: null,
      url: 'https://fed-exchange-api.herokuapp.com/api/v2.0/solicitationfilter?',
      dialog: false,
      startmenu: false,
      endmenu: false,
      totalItems: null,
      selectedItem: null,
      loading: true,
      pagination: {
        rowsPerPage: 25
      },
      heading: 'Department of Defense Contract History',
      noticetypes: ['All Notices', 'A'],
      kendoSchema: [{
        field: "posteddate",
        title: "Date",
        editable: false,
        format: "{0:MM-dd-yyyy}"
      }, {
        field: "solicitationname",
        title: "Title",
        editable: false
      }, {
        field: "agency",
        title: "Agency",
        editable: false
      }, {
        field: "noticetype",
        title: "Notice Type",
        editable: false
      }, {
        field: "naicscode",
        title: "NAICS Code",
        editable: false,
        type: "number",
        hidden: true
      }, {
        field: "setaside",
        title: "Set-Aside",
        editable: false
      }, {
        field: "primarypointofcontact",
        title: " Point of Contact",
        hidden: true
      }],
      count: 0,
      filters: {
        values: {
          startdate: null,
          enddate: null,
          psc: '',
          naics: '',
          search: '',
          type: 'award'
        }
      }
    };
  },
  watch: {
    pagination: function pagination(val) {
      var _this = this;

      var skip = 0;
      this.loading = true;

      if (val.page > 1) {
        skip = this.count * val.page;
      }

      this.$store.dispatch('getOpportunities', {
        type: 'award',
        skip: skip,
        limit: val.rowsPerPage
      }).then(function (res) {
        _this.totalItems = res.data.total;
        _this.count = res.data.data.length;
        _this.loading = false;
        return res;
      });
    },
    filters: {
      handler: function handler(val) {
        var query = 'https://fed-exchange-api.herokuapp.com/api/v2.0/solicitationfilter?';
        var payload = val.values;

        if (payload && payload.type) {
          query += "&type=".concat(payload.type);
        }

        if (payload && payload.psc) {
          query += "&psc=".concat(payload.psc);
        }

        if (payload && payload.naics) {
          query += "&naics=".concat(payload.naics);
        }

        if (payload && payload.startdate && payload.enddate) {
          query += "&daterange=".concat(payload.startdate, "to").concat(payload.enddate);
        }

        if (payload && payload.search) {
          query += "&keywords=".concat(payload.search);
        }

        this.url = query;
        this.$store.dispatch('setUrlHash', {
          base: 'awarded',
          values: val.values
        });
      },
      deep: true
    }
  },
  methods: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['getOpportunities'])), {}, {
    saveFilters: function saveFilters() {
      this.$firebase.database().ref("filters/awardedopportunities/".concat(this.$store.getters.getUserDetails.uid)).set(this.filters);
    },
    moreInfo: function moreInfo(item) {
      this.dialog = true;
      this.selectedItem = item;
    },
    clearFilters: function clearFilters() {
      this.filters.values = {
        startdate: null,
        enddate: null,
        psc: '',
        naics: '',
        search: '',
        type: 'award'
      };
    },
    selectRow: function selectRow(e) {
      this.selectedRow = e;
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    var payload = {
      meta: {
        'h1': this.$store.getters.getPages.awardedopportunities.header,
        'title': this.$store.getters.getPages.awardedopportunities.header,
        'description': 'Search active Department of Defense solicitations by utilizing the Active Contract Opportunities Module. Use the functionality n this module to stratergize, connect, and colaborate with other contractors to pursue specefic contract opportunities',
        'keywords': 'opportunities, defense opportunities, department of defense, defense',
        'requiresAuth': true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit('setHeaderInfo', payload);
    var self = this;
    this.$on('cancel', function () {
      self.dialog = false;
    });
    this.clearFilters();
    this.getOpportunities({
      type: 'award'
    }).then(function (res) {
      _this2.totalItems = res.data.total;
      _this2.count = res.data.data.length;
      _this2.loading = false;
      return res;
    }); // this.$firebase.database().ref(`filters/awardedopportunities/${this.$store.getters.getUserDetails.uid}`).once('value')
    //   .then(snapshot => {
    //     const filter = snapshot.val()
    //     if (filter.values) {
    //       this.filters = filter
    //     }
    //   })
  },
  computed: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['getOpportunitiesState'])), {}, {
    items: function items() {
      var data = this.getOpportunitiesState.data;
      return data;
    },
    pages: function pages() {
      return this.pagination.rowsPerPage ? Math.ceil(this.items.length / this.pagination.rowsPerPage) : 0;
    },
    pageData: function pageData() {
      return this.$store.getters.getPages;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  })
};

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".postdate-width{width:120px!important}.text-uppercase{text-transform:uppercase!important}.new-green{background:#64d085!important}.full-width{width:100%!important}.text-white{color:#fff!important}.bg-white{background:#fff!important}.textLeft{padding-left:10px!important}th.column.text-xs-center{text-align:left!important;padding-left:0!important;font-size:12px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/AwardedOpportunitiesView.vue"],"names":[],"mappings":"AACA,gBACE,qBAAuB,CACxB,AACD,gBACE,kCAAqC,CACtC,AACD,WACE,4BAA+B,CAChC,AACD,YACE,oBAAuB,CACxB,AACD,YACE,oBAAuB,CACxB,AACD,UACE,yBAA4B,CAC7B,AACD,UACE,2BAA8B,CAC/B,AACD,yBACE,0BAA4B,AAC5B,yBAA6B,AAC7B,cAAgB,CACjB","file":"AwardedOpportunitiesView.vue","sourcesContent":["\n.postdate-width {\n  width: 120px !important\n}\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n.new-green {\n  background: #64d085 !important;\n}\n.full-width {\n  width: 100% !important;\n}\n.text-white {\n  color: #fff !important;\n}\n.bg-white {\n  background: #fff !important;\n}\n.textLeft{\n  padding-left: 10px !important;\n}\nth.column.text-xs-center {\n  text-align: left !important;\n  padding-left: 0px !important;\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1462:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1373);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("71528c48", content, true, {});

/***/ }),

/***/ 1665:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_c('v-container', {
    style: ({
      backgroundColor: _vm.styles.general.background_color
    })
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-card', {
    staticClass: "new-green px-3 pt-3 pb-2",
    attrs: {
      "flat": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('p', {
    staticClass: "text-white",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.pageData.awardedopportunities.sub_text) + "\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "bg-white px-2 pt-2 pb-2"
  }, [_c('v-layout', {
    staticClass: "mb-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md12": ""
    }
  }, [_c('b', [_vm._v("Filters")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "single-line": "",
      "placeholder": "NAICS"
    },
    model: {
      value: (_vm.filters.values.naics),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "naics", $$v)
      },
      expression: "filters.values.naics"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "light": "",
      "hide-details": "",
      "single-line": "",
      "placeholder": "PSC"
    },
    model: {
      value: (_vm.filters.values.psc),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "psc", $$v)
      },
      expression: "filters.values.psc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "light": "",
      "hide-details": "",
      "single-line": "",
      "placeholder": "Search"
    },
    model: {
      value: (_vm.filters.values.search),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "search", $$v)
      },
      expression: "filters.values.search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-menu', {
    staticClass: "mt-0",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.startmenu),
      callback: function($$v) {
        _vm.startmenu = $$v
      },
      expression: "startmenu"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "slot": "activator",
      "placeholder": "Start Date",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filters.values.startdate),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "startdate", $$v)
      },
      expression: "filters.values.startdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": save
          }
        }, [_vm._v("OK")])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.values.startdate),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "startdate", $$v)
      },
      expression: "filters.values.startdate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-1",
    attrs: {
      "md2": ""
    }
  }, [_c('v-menu', {
    staticClass: "mt-0",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.endmenu),
      callback: function($$v) {
        _vm.endmenu = $$v
      },
      expression: "endmenu"
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "slot": "activator",
      "placeholder": "End Date",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filters.values.enddate),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "enddate", $$v)
      },
      expression: "filters.values.enddate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": save
          }
        }, [_vm._v("OK")])], 1)]
      }
    }]),
    model: {
      value: (_vm.filters.values.enddate),
      callback: function($$v) {
        _vm.$set(_vm.filters.values, "enddate", $$v)
      },
      expression: "filters.values.enddate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-3",
    staticStyle: {
      "margin-top": "-8px !important"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearFilters.apply(null, arguments)
      }
    }
  }, [_vm._v("Clear filters")])], 1)], 1), _vm._v(" "), _c('kendo-table', {
    ref: "kendoTable",
    attrs: {
      "kendo-schema": _vm.kendoSchema,
      "url": _vm.url
    },
    on: {
      "view": _vm.moreInfo,
      "change": _vm.selectRow
    }
  })], 1)])], 1), _vm._v(" "), _c('side-view-chat'), _vm._v(" "), _c('opportunities-modal', {
    attrs: {
      "dialog": _vm.dialog,
      "item": _vm.selectedItem
    }
  })], 1), _vm._v(" "), _c('site-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1462)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1259),
  /* template */
  __webpack_require__(1665),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(833)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(834),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      show: false,
      unread: 0,
      contacts: []
    };
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    privileges: function privileges() {
      return this.$store.getters.getUserPrivileges;
    }
  },
  methods: {
    openChat: function openChat() {
      window.$applozic('#mck-sidebox').mckModal('show');
      window.$applozic.fn.applozic('loadTab', '');
      window.$('html').addClass('sidebox-open');
      this.setDefaultContacts();
    },
    setDefaultContacts: function setDefaultContacts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var self, contactSnap, contacts, users, parentNode, noConversationNode, mckInner, nodes, fragment;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                _context.next = 3;
                return _this.$firebase.database().ref('default_chat_contact').once('value');

              case 3:
                contactSnap = _context.sent;
                contacts = contactSnap.val() || [];
                users = _this.$store.getters.fetchUsers;
                parentNode = document.getElementById('mck-contact-list');
                noConversationNode = document.getElementById('mck-no-conversations');
                mckInner = document.querySelector('#mck-message-cell .mck-message-inner');
                nodes = contacts.reduce(function (d, contact) {
                  var user = users.find(function (user) {
                    return user.uid === contact.uid;
                  }); // check if already exist

                  if (user) {
                    var contactExist = document.getElementById("li-user-".concat(user.uid));
                    if (contactExist) return d + '';
                    var node = self.getNode(user);
                    return d + node;
                  }

                  return d;
                }, '');
                fragment = document.createRange().createContextualFragment(nodes);

                if (!parentNode) {
                  mckInner.innerHTML = '<ul id="mck-contact-list" class="mck-contact-list mck-nav mck-nav-tabs mck-nav-stacked">';
                  parentNode = document.getElementById('mck-contact-list');
                }

                if (noConversationNode) {
                  setTimeout(function () {
                    noConversationNode.classList.remove('vis');
                    noConversationNode.classList.add('n-vis');
                  }, 800);
                }

                parentNode.prepend(fragment);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getNode: function getNode(user) {
      var avatar = user.avatar.indexOf('http') >= 0 ? user.avatar : "".concat(window.location.protocol, "//").concat(window.location.host).concat(user.avatar);
      var fullName = "".concat(user.firstname, " ").concat(user.lastname);
      return "\n      <li id=\"li-user-".concat(user.uid, "\" class=\"li-user-").concat(user.uid, " ").concat(user.uid, "\"\n        data-msg-time=\"1539049156786\"><a class=\"applozic-launcher\" href=\"#\" target=\"_self\" data-mck-conversationid=\"\"\n          data-mck-id=\"").concat(user.uid, "\" data-mck-clientgroupid=\"\" data-isgroup=\"false\">\n          <div class=\"mck-row\" title=\"").concat(fullName, "\">\n            <div class=\"mck-conversation-topic mck-truncate n-vis\"></div>\n            <div class=\"blk-lg-3\"><img src=\"").concat(avatar, "\"></div>\n            <div class=\"blk-lg-9\">\n              <div class=\"mck-row\">\n                <div class=\"blk-lg-8 mck-cont-name mck-truncate\">\n                  <div class=\"mck-ol-status n-vis\"><span class=\"mck-ol-icon\" title=\"Online\"></span>&nbsp;</div><strong>").concat(fullName, "</strong>\n                </div>\n                <div class=\"mck-text-muted move-right mck-cont-msg-date mck-truncate blk-lg-4\"></div>\n              </div>\n              <div class=\"mck-row\">\n                <div class=\"mck-cont-msg-wrapper blk-lg-6 mck-truncate msgTextExpr\">\n                  <p>Hello, how can I help you?</p>\n                </div>\n                <div class=\"mck-unread-count-box move-right mck-truncate n-vis\"><span class=\"mck-unread-count-text\">0</span></div>\n              </div>\n            </div>\n          </div>\n        </a>\n      </li>\n    ");
    }
  },
  beforeDestroy: function beforeDestroy() {
    var chatTotalUnreadCountId = Number(localStorage.getItem('chatTotalUnreadCountId'));
    window.clearInterval(chatTotalUnreadCountId);
    localStorage.removeItem('chatTotalUnreadCountId');
  },
  mounted: function mounted() {
    var _this2 = this;

    var self = this;
    var path = this.$route.path;
    this.$store.dispatch('loadUsers');
    if (!['/user/feed', '/contractors'].includes(path)) return;
    window.$applozic && window.$applozic.fn.applozic({
      appId: 'tsvcommunityxchange3b1149dc15a',
      userId: this.user.uid,
      userName: "".concat(this.user.firstname, "-").concat(this.user.lastname),
      imageLink: this.user.avatar,
      email: this.user.email,
      labels: {
        'last.seen.on': 'Last seen'
      },
      contactNumber: '',
      desktopNotification: true,
      source: '1',
      group: false,
      video: true,
      voice: true,
      notificationIconLink: 'https://www.applozic.com/favicon.ico',
      authenticationTypeId: 1,
      accessToken: '',
      locShare: false,
      // googleApiKey: "AIzaSyDKfWHzu9X7Z2hByeW4RRFJrD9SizOzZt4",
      googleApiKey: 'AIzaSyBCkHJdW4ChFLJ8cqJghc-LlhVU_FAl5G0',
      googleMapScriptLoaded: true,
      // mapStaticAPIkey: "AIzaSyCWRScTDtbt8tlXDr6hiceCsU83aS2UuZw",
      autoTypeSearchEnabled: true,
      loadOwnContacts: true,
      olStatus: true,
      onInit: function onInit(response) {
        if (response === 'success') {
          // calling function load contacts
          // const contactsJSON = self.$store.getters.fetchUsers
          //   .filter(val => val.id !== self.user.id)
          //   .map(user => {
          //     return {
          //       userId: user.id,
          //       displayName: `${user.firstname} ${user.lastname}`,
          //       imageLink:
          //         user.avatar.indexOf("http") < 0
          //           ? `${window.location.protocol}//${window.location.host}${
          //               user.avatar
          //             }`
          //           : user.avatar
          //     };
          //   });
          // self.contacts = contactsJSON;
          // $applozic.fn.applozic("loadContacts", { contacts: contactsJSON });
          // var startNew = document.getElementById('mck-msg-new')
          // startNew.addEventListener("mousemove", () => {
          //   $applozic.fn.applozic("loadContacts", { contacts: self.contacts });
          // });
          var closeButton = document.querySelector('.mck-box-close.mck-close-sidebox');
          closeButton.addEventListener('click', function () {
            window.$('html').removeClass('sidebox-open');
          });
          var chatTotalUnreadCountIntervalId = setInterval(function () {
            window.$applozic.fn.applozic('getUserDetail', {
              callback: function callback(response) {
                if (response.status === 'success') {
                  self.unread = response.data.totalUnreadCount;
                }
              }
            });
          }, 3000);
          window.localStorage.setItem('chatTotalUnreadCountId', chatTotalUnreadCountIntervalId);

          _this2.setDefaultContacts(); // watch for back icon click


          var backIconNodes = document.querySelectorAll('.mck-tab-link a.mck-conversation-tab-link');

          var _iterator = _createForOfIteratorHelper(backIconNodes),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var node = _step.value;
              node.addEventListener('click', function () {
                self.setDefaultContacts();
              });
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {// error in user login/register (you can hide chat button or refresh page)
        }
      },
      onTabClicked: function onTabClicked(response) {},
      contactDisplayName: function contactDisplayName(userId) {
        var users = self.$store.getters.fetchUsers;
        var contactUser = users.find(function (user) {
          return user.uid === userId;
        });

        if (contactUser) {
          return "".concat(contactUser.firstname, " ").concat(contactUser.lastname);
        }
      },
      contactDisplayImage: function contactDisplayImage(userId) {
        var users = self.$store.getters.fetchUsers;
        var contactUser = users.find(function (user) {
          return user.uid === userId;
        });

        if (contactUser) {
          return contactUser.avatar.indexOf('http') < 0 ? "".concat(window.location.protocol, "//").concat(window.location.host).concat(contactUser.avatar) : contactUser.avatar;
        }
      }
    });
  }
};

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sidebox-open{overflow:hidden!important}.chatbutton{width:66px;height:66px}#mck-contact-search-list{display:none!important}.mck-box input{line-height:inherit!important}.mck-box input::-webkit-input-placeholder{line-height:inherit!important}.mck-box input::-moz-placeholder{line-height:inherit!important}.mck-box input::-ms-input-placeholder{line-height:inherit!important}.mck-box input::placeholder{line-height:inherit!important}.mck-sidebox.fade.in{width:100%!important}.mck-alpha-contact-image img{width:43px!important;height:43px!important}.row.mck-vid-overlay-footer.mck-flex-footer{margin:0!important}.mck-vid-scr-controls{width:100%!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.row.mck-vid-overlay-header{padding-top:20px!important}.mck-vid-icon span{color:#fff!important}.mck-videocall-image{width:50px!important;height:50px!important;border-radius:100%!important}.footer-controls{width:auto!important;float:none!important;margin:0!important}.mck-contact-list .blk-lg-8{width:calc(100% - 55px)!important}.mck-running-on.vis{display:none!important}.mck-msg-box{min-height:0!important;font-size:15px!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;padding:16px 14px 10px!important}.applozic-vid-container{width:100%!important;padding:0!important;max-width:none!important}#mck-sidebox-launcher,.mck-sidebox-launcher{display:none!important}#mck-vid-icon{color:#fff!important;position:relative}#mck-vid-icon span{width:150px;display:block;position:absolute;left:-43px}.mck-vid-overlay-footer{margin-left:0!important}.mck-vid-scr-controls .footer-controls,.mck-vid-scr-controls .footer-controls button{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.mck-vid-scr-controls .footer-controls button{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;margin:4px!important}#mck-microfone-mute-btn{border-radius:50%;height:56px!important;width:56px!important}.unread{position:absolute!important;z-index:99999!important;color:#fff!important;font-size:12px!important;font-weight:700!important;background:red!important;top:0!important;right:0!important;height:20px!important;width:20px!important;border-radius:50%!important;-webkit-transform:rotate(0deg)!important;transform:rotate(0deg)!important;opacity:1!important;left:auto!important}", "", {"version":3,"sources":["/home/circleci/repo/src/components/chat/sideboxChat.vue"],"names":[],"mappings":"AACA,cACE,yBAA4B,CAC7B,AACD,YACE,WAAY,AACZ,WAAa,CACd,AACD,yBACE,sBAAyB,CAC1B,AACD,eACE,6BAAgC,CACjC,AACD,0CACE,6BAAgC,CACjC,AACD,iCACE,6BAAgC,CACjC,AACD,sCACE,6BAAgC,CACjC,AACD,4BACE,6BAAgC,CACjC,AACD,qBACE,oBAAuB,CACxB,AACD,6BACE,qBAAuB,AACvB,qBAAwB,CACzB,AACD,4CACE,kBAAqB,CACtB,AACD,sBACE,qBAAuB,AACvB,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,kCAAoC,AAChC,+BAAiC,AAC7B,gCAAmC,CAC5C,AACD,4BACE,0BAA6B,CAC9B,AACD,mBACE,oBAAuB,CACxB,AACD,qBACE,qBAAuB,AACvB,sBAAwB,AACxB,4BAA+B,CAChC,AACD,iBACE,qBAAuB,AACvB,qBAAuB,AACvB,kBAAqB,CACtB,AACD,4BACE,iCAAoC,CACrC,AACD,oBACE,sBAAyB,CAC1B,AACD,aACE,uBAA2B,AAC3B,yBAA2B,AAC3B,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,kCAAoC,AAChC,+BAAiC,AAC7B,iCAAmC,AAC3C,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,gCAAwC,CACzC,AACD,wBACE,qBAAuB,AACvB,oBAAwB,AACxB,wBAA2B,CAC5B,AAID,4CACE,sBAAyB,CAC1B,AACD,cACE,qBAAuB,AACvB,iBAAmB,CACpB,AACD,mBACE,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,UAAY,CACb,AACD,wBACE,uBAA4B,CAC7B,AAMD,qFAJE,8BAAgC,AAChC,8BAAgC,AAChC,sBAAyB,CAa1B,AAXD,8CAIE,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,kCAAoC,AAChC,+BAAiC,AAC7B,iCAAmC,AAC3C,oBAAuB,CACxB,AACD,wBACE,kBAAmB,AACnB,sBAAwB,AACxB,oBAAuB,CACxB,AACD,QACE,4BAA8B,AAC9B,wBAA0B,AAC1B,qBAAuB,AACvB,yBAA2B,AAC3B,0BAA4B,AAC5B,yBAA2B,AAC3B,gBAAoB,AACpB,kBAAsB,AACtB,sBAAwB,AACxB,qBAAuB,AACvB,4BAA8B,AAC9B,yCAA2C,AAC3C,iCAAmC,AACnC,oBAAsB,AACtB,mBAAsB,CACvB","file":"sideboxChat.vue","sourcesContent":["\n.sidebox-open {\n  overflow: hidden !important;\n}\n.chatbutton {\n  width: 66px;\n  height: 66px;\n}\n#mck-contact-search-list {\n  display: none !important;\n}\n.mck-box input {\n  line-height: inherit !important;\n}\n.mck-box input::-webkit-input-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::-moz-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::-ms-input-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::placeholder {\n  line-height: inherit !important;\n}\n.mck-sidebox.fade.in {\n  width: 100% !important;\n}\n.mck-alpha-contact-image img {\n  width: 43px !important;\n  height: 43px !important;\n}\n.row.mck-vid-overlay-footer.mck-flex-footer {\n  margin: 0 !important;\n}\n.mck-vid-scr-controls {\n  width: 100% !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n}\n.row.mck-vid-overlay-header {\n  padding-top: 20px !important;\n}\n.mck-vid-icon span {\n  color: #fff !important;\n}\n.mck-videocall-image {\n  width: 50px !important;\n  height: 50px !important;\n  border-radius: 100% !important;\n}\n.footer-controls {\n  width: auto !important;\n  float: none !important;\n  margin: 0 !important;\n}\n.mck-contact-list .blk-lg-8 {\n  width: calc(100% - 55px) !important;\n}\n.mck-running-on.vis {\n  display: none !important;\n}\n.mck-msg-box {\n  min-height: 0px !important;\n  font-size: 15px !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  padding: 16px 14px 10px 14px !important;\n}\n.applozic-vid-container {\n  width: 100% !important;\n  padding: 0px !important;\n  max-width: none !important;\n}\n#mck-sidebox-launcher {\n  display: none !important;\n}\n.mck-sidebox-launcher {\n  display: none !important;\n}\n#mck-vid-icon {\n  color: #fff !important;\n  position: relative;\n}\n#mck-vid-icon span {\n  width: 150px;\n  display: block;\n  position: absolute;\n  left: -43px;\n}\n.mck-vid-overlay-footer {\n  margin-left: 0px !important;\n}\n.mck-vid-scr-controls .footer-controls {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n.mck-vid-scr-controls .footer-controls button {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  margin: 4px !important;\n}\n#mck-microfone-mute-btn {\n  border-radius: 50%;\n  height: 56px !important;\n  width: 56px !important;\n}\n.unread {\n  position: absolute !important;\n  z-index: 99999 !important;\n  color: #fff !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  background: red !important;\n  top: 0px !important;\n  right: 0px !important;\n  height: 20px !important;\n  width: 20px !important;\n  border-radius: 50% !important;\n  -webkit-transform: rotate(0deg) !important;\n  transform: rotate(0deg) !important;\n  opacity: 1 !important;\n  left: auto !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(832);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("1e24f439", content, true, {});

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path === '/user/feed') ? _c('div', [(_vm.privileges.chat.private_chat) ? _c('v-btn', {
    staticClass: "chatbutton primary",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openChat.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticClass: "chaticon"
  }, [_vm._v("chat")]), _vm._v(" "), (_vm.unread) ? _c('span', {
    staticClass: "unread"
  }, [_vm._v(_vm._s(_vm.unread))]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      competitiveAdvantages: [{
        name: 'Infrastructure',
        link: 'http://www.georgia.org/competitive-advantages/infrastructure/'
      }, {
        name: 'Workforce',
        link: 'http://www.georgia.org/competitive-advantages/training-hiring/'
      }, {
        name: 'Tax Credits',
        link: 'http://www.georgia.org/competitive-advantages/tax-credits/'
      }],
      businessResources: [{
        name: 'Available Buildings Tool',
        link: 'http://www.georgia.org/siteselector/'
      }, {
        name: 'International Trade',
        link: 'http://www.georgia.org/business-resources/international-trade/'
      }, {
        name: 'Small Business & Entrepreneurs',
        link: 'http://www.georgia.org/business-resources/small-business-resource-directory/'
      }],
      industries: [{
        name: 'AeroSpace',
        link: 'http://www.georgia.org/industries/aerospace/'
      }, {
        name: 'Agribusiness',
        link: 'http://www.georgia.org/industries/agribusiness/'
      }, {
        name: 'Arts',
        link: 'http://www.georgia.org/industries/arts/'
      }, {
        name: 'Automotive',
        link: 'http://www.georgia.org/industries/automotive/'
      }, {
        name: 'Contact Center',
        link: 'http://www.georgia.org/industries/contact-centers/'
      }, {
        name: 'Data Center',
        link: 'http://www.georgia.org/industries/data-centers/'
      }, {
        name: 'Defense',
        link: 'http://www.georgia.org/industries/defense/'
      }, {
        name: 'Energy and Environment',
        link: 'http://www.georgia.org/industries/energy-solutions/'
      }, {
        name: 'Entertainment',
        link: 'http://www.georgia.org/industries/entertainment/'
      }, {
        name: 'Headquarters',
        link: 'http://www.georgia.org/industries/headquarters/'
      }, {
        name: 'Fintech',
        link: 'http://www.georgia.org/industries/fintech/'
      }, {
        name: 'Food Processing',
        link: 'http://www.georgia.org/industries/food-processing/'
      }, {
        name: 'Information Technology',
        link: 'http://www.georgia.org/industries/information-technology/'
      }, {
        name: 'Life Sciences',
        link: 'http://www.georgia.org/industries/life-sciences/'
      }, {
        name: 'Logistics and Transportation',
        link: 'http://www.georgia.org/industries/logistics-services/'
      }, {
        name: 'Advanced Manufacturing',
        link: 'http://www.georgia.org/industries/advanced-manufacturing/'
      }, {
        name: 'Tourism',
        link: 'http://www.georgia.org/industries/georgia-tourism/'
      }],
      year: ''
    };
  },
  created: function created() {
    this.year = new Date().getFullYear();
  },
  computed: {
    site_settings: function site_settings() {
      return this.$store.getters.getSettings;
    },
    landing_page: function landing_page() {
      return this.$store.getters.getSettings.pages.landing_pages;
    }
  }
};

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "h3[data-v-a9ce9c7e]{font-size:18px;font-family:Roboto;color:#fff;margin-top:5px;margin-bottom:5px}p[data-v-a9ce9c7e]{color:#f5f5f5;font-size:16px;margin-top:5px;margin-bottom:5px}a[data-v-a9ce9c7e]{color:#d5e14d;text-decoration:none;display:block}a[data-v-a9ce9c7e]:hover{color:#28a028}.footer-item[data-v-a9ce9c7e]{font-family:Roboto;background-image:-webkit-gradient(linear,left top,left bottom,from(#5b5b5c),to(#131314));background-image:linear-gradient(#5b5b5c,#131314);width:100%}.footer-bg[data-v-a9ce9c7e]{background:#f3f3f3;height:auto}.before-footer-content[data-v-a9ce9c7e]{height:150px}ul[data-v-a9ce9c7e]{list-style:none}ul li[data-v-a9ce9c7e]{display:inline-block;width:50%}.vertical-divider[data-v-a9ce9c7e]{clear:both;position:relative}.vertical-divider[data-v-a9ce9c7e]:after{clear:both;content:\" \";display:block;height:0;visibility:hidden}.vertical-divider .column[data-v-a9ce9c7e]:not(:first-child):after{background:#6d6d6d;bottom:0;content:\" \";margin-left:-10px;position:absolute;top:0;width:1px}hr .divider[data-v-a9ce9c7e]{background-color:#6d6d6d}.divider-flex-rows[data-v-a9ce9c7e]{width:90%;padding:15px 0;margin:auto}.divider-layout-rows[data-v-a9ce9c7e]{width:100%;padding:15px 0;margin:auto}.footer-copyright[data-v-a9ce9c7e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.footer-copyright img[data-v-a9ce9c7e]{height:50px;vertical-align:middle}.site-map[data-v-a9ce9c7e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.site-map a[data-v-a9ce9c7e]{margin:0 15px}.site-map img[data-v-a9ce9c7e]{height:50px;vertical-align:middle}.site-map-divider[data-v-a9ce9c7e]{clear:both;position:relative}.site-map-divider[data-v-a9ce9c7e]:after{clear:both;content:\" \";display:block;height:0;visibility:hidden}.site-map-divider .site-map-column[data-v-a9ce9c7e]:not(:first-child):after{background:#6d6d6d;bottom:0;content:\" \";margin-left:5px;position:absolute;top:0;width:1px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/SiteFooter.vue"],"names":[],"mappings":"AACA,oBACE,eAAgB,AAChB,mBAAoB,AACpB,WAAe,AACf,eAAgB,AAChB,iBAAmB,CACpB,AACD,mBACE,cAAkB,AAClB,eAAgB,AAChB,eAAgB,AAChB,iBAAmB,CACpB,AACD,mBACE,cAAe,AACf,qBAAsB,AACtB,aAAe,CAChB,AACD,yBACE,aAAe,CAChB,AACD,8BACE,mBAAoB,AACpB,yFAA8F,AAC9F,kDAAoD,AACpD,UAAY,CACb,AACD,4BACE,mBAAoB,AACpB,WAAa,CACd,AACD,wCACE,YAAc,CACf,AACD,oBACE,eAAiB,CAClB,AACD,uBACI,qBAAsB,AACtB,SAAW,CACd,AACD,mCACE,WAAY,AACZ,iBAAmB,CACpB,AACD,yCACE,WAAY,AACZ,YAAa,AACb,cAAe,AACf,SAAU,AACV,iBAAmB,CACpB,AACD,mEACE,mBAAoB,AACpB,SAAU,AACV,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,MAAO,AACP,SAAW,CACZ,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,UAAW,AACX,eAAgB,AAChB,WAAa,CACd,AACD,sCACE,WAAY,AACZ,eAAgB,AAChB,WAAa,CACd,AACD,mCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,uCACI,YAAa,AACb,qBAAuB,CAC1B,AACD,2BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,6BACI,aAAe,CAClB,AACD,+BACI,YAAa,AACb,qBAAuB,CAC1B,AACD,mCACE,WAAY,AACZ,iBAAmB,CACpB,AACD,yCACE,WAAY,AACZ,YAAa,AACb,cAAe,AACf,SAAU,AACV,iBAAmB,CACpB,AACD,4EACE,mBAAoB,AACpB,SAAU,AACV,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,SAAW,CACZ","file":"SiteFooter.vue","sourcesContent":["\nh3[data-v-a9ce9c7e] {\n  font-size: 18px;\n  font-family: Roboto;\n  color: #FFFFFF;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\np[data-v-a9ce9c7e] {\n  color: whitesmoke;\n  font-size: 16px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\na[data-v-a9ce9c7e] {\n  color: #d5e14d;\n  text-decoration: none;\n  display: block;\n}\na[data-v-a9ce9c7e]:hover {\n  color: #28a028;\n}\n.footer-item[data-v-a9ce9c7e] {\n  font-family: Roboto;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#5b5b5c), to(#131314));\n  background-image: linear-gradient(#5b5b5c, #131314);\n  width: 100%;\n}\n.footer-bg[data-v-a9ce9c7e] {\n  background: #f3f3f3;\n  height: auto;\n}\n.before-footer-content[data-v-a9ce9c7e] {\n  height: 150px;\n}\nul[data-v-a9ce9c7e] {\n  list-style: none;\n}\nul li[data-v-a9ce9c7e] {\n    display: inline-block;\n    width: 50%;\n}\n.vertical-divider[data-v-a9ce9c7e] {\n  clear: both;\n  position: relative;\n}\n.vertical-divider[data-v-a9ce9c7e]:after {\n  clear: both;\n  content: \" \";\n  display: block;\n  height: 0;\n  visibility: hidden;\n}\n.vertical-divider .column[data-v-a9ce9c7e]:not(:first-child):after {\n  background: #6d6d6d;\n  bottom: 0;\n  content: \" \";\n  margin-left: -10px;\n  position: absolute;\n  top: 0;\n  width: 1px;\n}\nhr .divider[data-v-a9ce9c7e] {\n  background-color: #6d6d6d;\n}\n.divider-flex-rows[data-v-a9ce9c7e] {\n  width: 90%;\n  padding: 15px 0;\n  margin: auto;\n}\n.divider-layout-rows[data-v-a9ce9c7e] {\n  width: 100%;\n  padding: 15px 0;\n  margin: auto;\n}\n.footer-copyright[data-v-a9ce9c7e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.footer-copyright img[data-v-a9ce9c7e] {\n    height: 50px;\n    vertical-align: middle;\n}\n.site-map[data-v-a9ce9c7e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.site-map a[data-v-a9ce9c7e] {\n    margin: 0 15px;\n}\n.site-map img[data-v-a9ce9c7e] {\n    height: 50px;\n    vertical-align: middle;\n}\n.site-map-divider[data-v-a9ce9c7e] {\n  clear: both;\n  position: relative;\n}\n.site-map-divider[data-v-a9ce9c7e]:after {\n  clear: both;\n  content: \" \";\n  display: block;\n  height: 0;\n  visibility: hidden;\n}\n.site-map-divider .site-map-column[data-v-a9ce9c7e]:not(:first-child):after {\n  background: #6d6d6d;\n  bottom: 0;\n  content: \" \";\n  margin-left: 5px;\n  position: absolute;\n  top: 0;\n  width: 1px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(872);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("71a8954f", content, true, {});

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(874)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(878),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a9ce9c7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 878:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item"
  }, [_c('v-layout', {
    staticClass: "before-footer-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container')], 1), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "background-color": "#d5e14d"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "hidden-sm-down": ""
    }
  }, [_c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("INDUSTRIES IN GEORGIA")]), _vm._v(" "), _c('v-flex', [_c('ul', {
    staticClass: "industry-item"
  }, _vm._l((_vm.industries), function(industry, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": industry.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(industry.name))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "hidden-sm-down": ""
    }
  }, [_c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("COMPETITIVE ADVANTAGE")]), _vm._v(" "), _vm._l((_vm.competitiveAdvantages), function(advantage, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": advantage.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(advantage.name))])
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-flex-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("BUSINESS RESOURCES")]), _vm._v(" "), _vm._l((_vm.businessResources), function(resource, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": resource.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(resource.name))])
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "social-media-footer column",
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md-12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md-12": ""
    }
  }, [_c('h3', [_vm._v("CONNECT WITH US")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-email")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-facebook-box")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-youtube-play")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-rss")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-flex-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "contact-us column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("CONTACT US")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.georgia.org/about-us/contact-us/"
    }
  }, [_vm._v("Use our Contact form")]), _vm._v(" "), _c('p', [_vm._v("Call us at +1-404-962-4000")]), _vm._v(" "), _c('p', [_vm._v("+1-800-255-0056 for the hearing impaired")]), _vm._v(" "), _c('p', [_vm._v("Georgia Department of Economic Development")]), _vm._v(" "), _c('p', [_vm._v("Technology Square, 75 5th Street N.W., Suite 1200 Atlanta, GA 30308")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-layout-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "site-map site-map-divider",
    attrs: {
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "site-map-column"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/footer-we_speak_business.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.georgia.org/sitemap",
      "target": "blank"
    }
  }, [_vm._v("Site Map")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.exploregeorgia.org/?_ga=2.117864841.1812343620.1523235297-576062532.1522934539",
      "target": "blank"
    }
  }, [_vm._v("ExploreGeorgia.org")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gaarts.org/",
      "target": "blank"
    }
  }, [_vm._v("GaArts.org")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://siteselector.georgia.org/?_ga=2.117864841.1812343620.1523235297-576062532.1522934539",
      "target": "blank"
    }
  }, [_vm._v("GeorgiaSiteSelector")])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-layout-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "footer-copyright",
    attrs: {
      "md12": ""
    }
  }, [_c('p', [_vm._v("© " + _vm._s(_vm.year) + " Georgia Department of Economic Development. All Rights Reserved.")]), _vm._v(" "), _c('p', [_vm._v("GDEcD is an equal opportunity employer.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/footer-logo.png"
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/32.d676198600b90115bb74.js